import * as z from "zod";

export const getOutreachUnsubscribes = {
  name: "getOutreachUnsubscribes" as const,
  input: z.object({ campaignId: z.string() }),
  output: z.object({ unsubscribes: z.number() }),
};
